import { render } from "./Markdown.vue?vue&type=template&id=07b0707a"
import script from "./Markdown.vue?vue&type=script&lang=js"
export * from "./Markdown.vue?vue&type=script&lang=js"

import "./Markdown.vue?vue&type=style&index=0&id=07b0707a&lang=scss"
script.render = render

export default script